import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as UserCheck } from 'assets/images/user-check.svg';

export const UserCheckIcon = styled(UserCheck)`
  width: 21px;
  height: 23px;
  color: ${ColorPalette.HEX.RedRYB};
  margin: 32px 24px 0;
`;
